import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=9b9ddaa4&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b9ddaa4')) {
      api.createRecord('9b9ddaa4', component.options)
    } else {
      api.reload('9b9ddaa4', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=9b9ddaa4&", function () {
      api.rerender('9b9ddaa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Uvb14RvYWP8G/JS/offershelp.vue"
export default component.exports